import React, { useEffect, useState, lazy, Suspense } from "react";
import { Spin } from "antd";

const MatchesDesktop = lazy(() => import("./match-management-desktop"));
const MatchesMobile = lazy(() => import("./match-management-mobie"));

const MatchManagement = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateLayout = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 900);
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  return (
    <Suspense fallback={<Spin fullscreen size="large" tip="Đang tải giao diện..." />}>
      {isMobile ? <MatchesMobile /> : <MatchesDesktop />}
    </Suspense>
  );
};

export default MatchManagement;